import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="border-b border-crema bg-blanco" data-id="element-17" data-mp="bfj6p4q0ph8">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:py-9" data-id="element-18" data-mp="3ipotjepgrobh">
        <SectionHeader id="beneficios" title="¿Qué puede cambiar cuando empezás?" description="Pequeñas decisiones pueden ayudarte a recuperar dirección." data-id="element-19" data-mp="3norm3zo9c22k" />
        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="3dqvbd8z8f94z">
          {benefits.map(({
          icon: Icon,
          title,
          desc
        }) => <li key={title} className="flex gap-2.5 rounded-xl border border-crema bg-crema/40 p-3" data-id="element-21" data-mp="2zs3zzubr81kj">
              <span aria-hidden="true" className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-petroleo/10 text-petroleo" data-id="element-22" data-mp="34rgoeji9xgp8">
                <Icon size={16} data-id="element-23" data-mp="12zc2bonghdmf" />
              </span>
              <div data-id="element-24" data-mp="12wpv5q4h904q">
                <h3 className="text-sm font-extrabold text-azul" data-id="element-25" data-mp="2bexlx978wyvu">{title}</h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-azul/80 sm:text-sm" data-id="element-26" data-mp="2bct5jrs5u7eo">{desc}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}